import type { FC, SVGProps } from "react";

const IconBoatTour: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M21 17H1C1 18.0609 1.42143 19.0783 2.17157 19.8284C2.92172 20.5786 3.93913 21 5 21H17C18.0609 21 19.0783 20.5786 19.8284 19.8284C20.5786 19.0783 21 18.0609 21 17Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20 13L9 1L2 13H20Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9 1V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconBoatTour;